














import { Component, Vue, Prop } from "vue-property-decorator";
import CustomContentTransfer from "./custom-content-transfer.vue";
@Component({
  components: {
    CustomContentTransfer
  }
})
export default class extends Vue {
  @Prop()
  private content: any;
  @Prop()
  private detail: any;
  private contentChange() {
    this.$emit("update:content", this.content);
  }
  private detailChange() {
    this.$emit("update:detail", this.detail);
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.detail["content_id"]) {
      this.content["模板"] = this.detail.data;
    }
  }
}
